import './controls/input';
import IMask from './core/holder';
export default IMask;
